module.exports = __webpack_public_path__ + "static/media/mca-architects.e450fc6e.png";